import { SyntheticEvent } from 'react';

import { ConfiguracaoPedidoAutoComplete } from 'components/autocompletes';
import { useApplicationContext } from 'context/ApplicationContext';
import { useClientContext } from 'context/ClientContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { FilterValuesProps } from 'hooks/useFilter';
import { RequestOptionsType } from 'hooks/useRequestListagem';
import { usePedidoFilterContext } from 'pages/compra/pedido/contexts/PedidoFilterContext';
import { ConfigPedidoProps } from 'pages/compra/pedido/types';

export function PedidoConfigPedidoAutoComplete() {
    const { user } = useApplicationContext();
    const { tipoPedido } = useClientContext();
    const { filterLoja, filterConfigPedido, setFilterConfigPedido, setFilterCategoria, setFilterMarca } = usePedidoFilterContext();
    const { hasPermission } = usePermissionsContext();
    const hasAcessoGeral = hasPermission(['COMPRA_PEDIDO_ACESSO_GERAL']);
    const idLoja = filterLoja.value?.idLoja;
    const filterFgVisivel = ['FRANQUEADO', 'FUNCIONARIO'].includes(user.tipoUsuario.tipoUsuarioEnum) && !hasAcessoGeral;

    const requestOptions: RequestOptionsType = {
        url: '/gestao/configpedido/vigente/loja',
        columns:
            'idConfigPedido,dsConfigPedido,idTipoControleEstoquePedido,fgValidaQuantidadeMinimaMultiploProduto,' +
            'vlBaseFreteGratis,peRoyaltiesLoja,peRoyalties,vlPedidoMinimoLoja,idTipoControlePedidoMinimo',
        limit: 9999,
        sort: [{ property: 'idConfigPedido', direction: 'DESC' }],
        filter: [
            { property: 'idLoja', operator: 'eq', value: filterLoja.value?.idLoja },
            { property: 'idConfigPedidoStatus', operator: 'eq', value: 2 },
        ],
    };

    if (filterFgVisivel) {
        requestOptions?.filter?.push({ property: 'fgVisivel', operator: 'eq', value: true });
    }

    /**
     * Ao trocar a configuração do pedido, limpa os campos de marca e jornada e atualiza o valor da configuração do pedido.
     */
    const onChangeConfigPedido = (e: SyntheticEvent<Element, Event>, value: ConfigPedidoProps) => {
        setFilterCategoria((oldState: FilterValuesProps) => ({ ...oldState, value: null }));

        setFilterMarca((oldState: FilterValuesProps) => ({ ...oldState, value: null }));

        setFilterConfigPedido((oldState: FilterValuesProps) => ({
            ...oldState,
            value: value && {
                idConfigPedido: value.idConfigPedido,
                dsConfigPedido: value.dsConfigPedido,
                vlPedidoMinimoLoja: value.vlPedidoMinimoLoja,
                tpControlePedidoMinimoLoja: value.tpControlePedidoMinimoLoja,
                idTipoControleEstoquePedido: value.idTipoControleEstoquePedido,
                configPedidoRegraValidacao: value.configPedidoRegraValidacao,
            },
        }));
    };

    return (
        <ConfiguracaoPedidoAutoComplete
            size="small"
            label={tipoPedido === 'funcionario' ? 'Campanha de produtos' : undefined}
            disabled={!idLoja}
            value={filterConfigPedido.value}
            requestOptions={idLoja ? requestOptions : null}
            onChange={onChangeConfigPedido}
        />
    );
}
